import React, { Component } from "react";
import { Spin, message, Radio, Modal } from "antd";
import Bridge from "../../../utils/Bridge";
import { le_study_demographics_form_type } from "../../../utils/consts";
import moment from "moment";
import { RESEARCH_TYPE, LE_STUDY_CONSENT_FORM_URLS } from "../../../utils/consts";

import englishJson from "../../../utils/language/leStudy/english.json";
import spanishJson from "../../../utils/language/leStudy/spanish.json";
import noLanguageJson from "../../../utils/language/leStudy/noLanguage.json";
import ConsentFormPdfViewer from "../../../components/ConsentFormPdfViewer";
import { logEvent } from "../../../utils/analytics";

export default class ConsentFormChild extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      is_consent_form_signed: false,
      neurostamp_id: "",
      modality_id: "",
      email: "",
      i_accept_checkbox: "",
      consent_form_date: null,
      readInSpanish: false,
      language: this.props.language,
      full_name: "",
      showConsentUpdateModal: false,
      isNewConsentSigned: false,
      hasOldConsentArchived: false,
      legacyConsentSigned: "",
      legacyConsentSignedDate: "",
      legacyConsentFullName: "",
    };
  }
  componentDidMount() {
    if (RESEARCH_TYPE == "LE Study") {
      if (localStorage.getItem("ap_language") == "Spanish only") {
        this.setState({ readInSpanish: true });
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // Automatically set the consent form date to current date and time
    const currentDateTime = moment().format("MM/DD/YYYY HH:mm");
    this.setState({ consent_form_date: currentDateTime });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params =
      "?participants_accounts_id=" +
      localStorage.getItem("ap_participants_accounts_id") +
      "&type=" +
      le_study_demographics_form_type.consent_form +
      "&eals_id=" +
      localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            let isNewConsentSigned = false;
            let hasOldConsentArchived = false;
            let legacyConsentSigned = "";
            let legacyConsentSignedDate = "";
            let legacyConsentFullName = "";

            for (let item of response.data) {
              if (item.field == "New Consent form signed") {
                if (
                  item.value == "Yes" ||
                  item.value === true ||
                  item.value == "1"
                ) {
                  isNewConsentSigned = true;
                }
              }
              if (item.field == "Old Consent form signed?") {
                hasOldConsentArchived = true;
              }
              if (item.field == "Consent form signed?") {
                legacyConsentSigned = item.value || "";
              }
              if (item.field == "Consent form signed Date") {
                legacyConsentSignedDate = item.value || "";
              }
              if (item.field == "Consent Form Full Name") {
                legacyConsentFullName = item.value || "";
              }
            }

            const hasLegacyConsent =
              legacyConsentSigned === "Yes" ||
              legacyConsentSigned === true ||
              legacyConsentSigned == "1";
            const showResignPopup = hasLegacyConsent && !isNewConsentSigned;

            this.setState({
              isNewConsentSigned,
              hasOldConsentArchived,
              legacyConsentSigned,
              legacyConsentSignedDate,
              legacyConsentFullName,
              showConsentUpdateModal: showResignPopup,
            });

            if (isNewConsentSigned) {
              this.props.set_active_step(1);
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save_details = () => {
    // Check if user has not selected any option (empty string means unselected)
    if (
      this.state.i_accept_checkbox === "" ||
      this.state.i_accept_checkbox === undefined ||
      this.state.i_accept_checkbox === null
    ) {
      if (this.props.language == "English") {
        message.warning("Please select either 'I Accept' or 'I Do Not Agree'");
      } else if (this.props.language == "Spanish") {
        message.warning(
          "Por favor, seleccione 'Acepto' o 'No estoy de acuerdo'"
        );
      }
      return;
    }
    // If user selected "I Do Not Agree" (false), redirect
    if (this.state.i_accept_checkbox === false) {
      window.location.assign("/");
      localStorage.clear();
      return;
    }
    // Ensure consent form date is set to current date and time before saving
    const currentDateTime = moment().format("MM/DD/YYYY HH:mm");
    this.setState({ consent_form_date: currentDateTime }, () => {
      this.proceedWithSave(currentDateTime);
    });
  };
  proceedWithSave = (currentDateTime) => {
    if (this.props.language == "English") {
      if (!this.state.i_accept_checkbox) {
        message.warning("Please accept the consent form");
        return;
      }
      if (!this.state.full_name) {
        message.warning("Please enter your full name");
        return;
      }
    } else if (this.props.language == "Spanish") {
      if (!this.state.i_accept_checkbox) {
        message.warning("Por favor, acepte el consentimiento del formulario");
        return;
      }
      if (!this.state.full_name) {
        message.warning("Por favor, ingrese su nombre completo");
        return;
      }
    }
    const legacyFields = [
      {
        parent_field: "Consent form signed?",
        field: "Consent form signed?",
        value: "Yes",
      },
      {
        parent_field: "Consent form signed Date",
        field: "Consent form signed Date",
        value: currentDateTime,
      },
      {
        parent_field: "Consent Form Full Name",
        field: "Consent Form Full Name",
        value: this.state.full_name,
      },
    ];

    let questions = [...legacyFields];

    if (!this.state.isNewConsentSigned) {
      const hasLegacyConsentSigned =
        this.state.legacyConsentSigned === "Yes" ||
        this.state.legacyConsentSigned === true ||
        this.state.legacyConsentSigned == "1";

      if (!this.state.hasOldConsentArchived && hasLegacyConsentSigned) {
        questions = [
          {
            parent_field: "Old Consent form signed?",
            field: "Old Consent form signed?",
            value: this.state.legacyConsentSigned,
          },
          {
            parent_field: "Old Consent form signed Date",
            field: "Old Consent form signed Date",
            value: this.state.legacyConsentSignedDate,
          },
          {
            parent_field: "Old Consent Form Full Name",
            field: "Old Consent Form Full Name",
            value: this.state.legacyConsentFullName,
          },
          ...legacyFields,
        ];
      }

      questions.push({
        parent_field: "New Consent form signed",
        field: "New Consent form signed",
        value: "Yes",
      });
    }
    let params = {
      data: JSON.stringify(questions),
      step: le_study_demographics_form_type.consent_form,
      email: this.state.email,
      participants_accounts_id: localStorage.getItem(
        "ap_participants_accounts_id"
      ),
      eals_id: localStorage.getItem("ap_eals_id"),
      type: le_study_demographics_form_type.consent_form,
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("consent_form_submitted");
          const formData =
            this.state.language === "English"
              ? englishJson
              : this.state.language === "Spanish"
                ? spanishJson
                : noLanguageJson;
          message.success(
            formData.page.consentForm.messages.consentFormSignedSuccessfully
          );
          this.setState(
            {
              loading: false,
            },
            () => {
              // window.location.assign('/dashboard')
              // if (present_non_als == true) {
              this.props.set_active_step(1);
              //   this.props.set_non_als_user(present_non_als);
              // } else {
              //   this.props.set_active_step(8);
              //   this.props.set_non_als_user(present_non_als);
              // }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  getFormData = () => {
    if (this.state.language === "English") {
      return englishJson;
    }
    if (this.state.language === "Spanish") {
      return spanishJson;
    }
    return noLanguageJson;
  };
  logout = () => {
    localStorage.clear();
    window.location.assign("/");
  };
  handleConsentUpdateCancel = () => {
    const formData = this.getFormData();
    const loggedOutMessage =
      formData.page.consentForm.consentUpdatePopup?.loggedOutSuccessfully ||
      "Logged out successfully.";

    message.success(loggedOutMessage);
    this.setState({ showConsentUpdateModal: false });
    setTimeout(() => {
      this.logout();
    }, 1500);
  };
  closeConsentUpdateModal = () => {
    this.setState({ showConsentUpdateModal: false });
  };
  render() {
    const formData =
      this.state.language === "English"
        ? englishJson
        : this.state.language === "Spanish"
          ? spanishJson
          : noLanguageJson;
    const consentUpdatePopup = formData.page.consentForm.consentUpdatePopup || {};

    return (
      <div>
        {RESEARCH_TYPE === "LE Study" && (
          <Modal
            open={this.state.showConsentUpdateModal}
            footer={null}
            closable={false}
            maskClosable={false}
            centered
            width={440}
            className="le-consent-update-modal"
          >
            <div className="le-consent-update-modal__body">
              <p className="le-consent-update-modal__message">
                {consentUpdatePopup.message}
              </p>
              <div className="le-consent-update-modal__actions">
                <button
                  type="button"
                  className="le-consent-update-modal__btn le-consent-update-modal__btn--continue"
                  onClick={this.closeConsentUpdateModal}
                >
                  {consentUpdatePopup.continue || "Continue"}
                </button>
              </div>
            </div>
          </Modal>
        )}
        <div className="header">
          <h3>{formData.page.consentForm.title}</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group pdf-div">
              <ConsentFormPdfViewer
                src={
                  this.props.language == "English"
                    ? LE_STUDY_CONSENT_FORM_URLS.newEnglish
                    : LE_STUDY_CONSENT_FORM_URLS.newSpanish
                }
                title="Consent Form"
                height={600}
              />
            </div>
            <div className="form-group">
              <Radio.Group
                onChange={(event) =>
                  this.setState({ i_accept_checkbox: event.target.value })
                }
                value={this.state.i_accept_checkbox}
                style={{ fontSize: 17 }}
              >
                <Radio value={true} style={{ fontSize: 17 }}>
                  {formData.page.consentForm.iAccept}
                </Radio>
                <Radio value={false} style={{ fontSize: 17 }}>
                  {formData.page.consentForm.doNotAccept}
                </Radio>
              </Radio.Group>
            </div>
            <div className="row">
              <div className="form-group col-lg-5 pl-0">
                <label
                  htmlFor="consent-form-full-name mb-2"
                  style={{ fontSize: 17, marginBottom: 10 }}
                >
                  {formData.page.consentForm.fullName}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="consent-form-full-name"
                  className="form-control"
                  value={this.state.full_name || ""}
                  onChange={(e) => this.setState({ full_name: e.target.value })}
                  required
                />
              </div>
              <div className="form-group col-lg-5 pl-0">
                <label
                  htmlFor="consent-form-date mb-2"
                  style={{ fontSize: 17, marginBottom: 10 }}
                >
                  {formData.page.consentForm.consentFormDate}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="consent-form-date"
                  className="form-control"
                  value={
                    this.state.consent_form_date ||
                    moment().format("MM/DD/YYYY HH:mm")
                  }
                  readOnly
                  style={{
                    height: "58px",
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                  }}
                />
              </div>
            </div>
            <button
              className="submit-button"
              style={{ padding: "9px 15px 10px 20px", width: "fit-content" }}
              onClick={() => this.save_details()}
            >
              {formData.page.consentForm.buttons.signAndSubmit}{" "}
              <box-icon
                name="chevron-right"
                color="#fff"
                style={{ position: "relative", top: 1 }}
              ></box-icon>
            </button>
          </div>
        </Spin>
      </div>
    );
  }
}
